import jwt_decode from 'jwt-decode';
import { addSeconds } from "date-fns";

import logger from 'debug';
import { isNullOrEmptyString } from './object-utils';
const debug = logger('login:helpers');

export const isTokenExpired = (token) => {
	if (isNullOrEmptyString(token))
		return true;

	let decoded = jwt_decode(token);
	const { exp } = decoded;
	// debug('decoded token', decoded);

	let expDate = new Date(exp * 1000);
	debug('expDate', expDate);

	let dateToCheck = Date.now();
	debug('dateToCheck', dateToCheck);

	if (dateToCheck >= expDate) {
		return true;
	}

	return false;
}

export const isTokenExpiring = (token) => {
	if (isNullOrEmptyString(token))
		return true;

	let decoded = jwt_decode(token);
	const { exp } = decoded;

	let expDate = new Date(exp * 1000);
	debug('expDate', expDate);

	// 300 = 5 minutes; 420 = 7 minutes; 
	let dateToCheck = addSeconds(Date.now(), 300);
	debug('dateToCheck', dateToCheck);

	if (dateToCheck >= expDate) {
		return true;
	}

	return false;
}